import { Box } from '@mui/material';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';
@autobind
export default class CardField extends Component {
    static propTypes = {
        name: PropTypes.string,
        handleClick: PropTypes.func,
        selected: PropTypes.string,
    };

    render() {
        const { name, handleClick, selected } = this.props;

        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    borderRadius: 2,
                    boxShadow: 2,
                    px: 3,
                    py: 1,
                    height: 30,
                    cursor: 'pointer',
                    ml: 1,
                    mb: 1,
                    ':hover': {
                        background: (t) => t.palette.primary[100],
                    },
                    ...(selected === name && { background: (t) => t.palette.primary.light }),
                }}
                onClick={handleClick}
            >
                <div className={styles.titleButton}>
                    <Title className={styles.title}>{name}</Title>
                </div>
            </Box>
        );
    }
}
